import { recordErrorEvent } from "@amzn/loom-navbar-api";

/**
 * Reports a fatal error to Loom's console health dashboard.
 * Only call for genuine application failures — not warnings or expected error states.
 */
export const reportFatalError = (error: Error, context: string) => {
  try {
    recordErrorEvent({
      eventContext: context,
      eventDetail: error.message || "UnknownError",
      stackTrace: error.stack,
    });
  } catch (e) {
    console.debug("[Loom] Failed to record error event:", e);
  }
};
